import React from 'react'

const Header = () => {
  return (
    <div className='header'>
        <h1>Fast React Pizza Co.</h1>
    </div>
  )
}

export default Header